import Page from "./page";

export default class Resource extends Page {}
